<template>
  <div class="login">
    <!--导航栏-->
    <header-nav></header-nav>

    <div class="container" :class="{'right-panel-active': isAddClass}" id="container">
      <div v-if="isAddClass && advert.register && advert.register.images" class="overlay-container" :style="`background-image: url('${API_URL+advert.register.images}')`"></div>
      <div v-else-if="!isAddClass && advert.login && advert.login.images" class="overlay-container" :style="`background-image: url('${API_URL+advert.login.images}')`"></div>
      <div v-else class="overlay-container" :style="`background-image: url('${IMG_URL}images/reg_bg.jpg')`"></div>

      <div v-if="isAddClass" class="form-container sign-up-container">
        <h1 class="form-title">欢迎注册</h1>
        <div class="form-item">
          <span class="iconfont icon-qq"></span>
          <input type="text" placeholder="请输入您的QQ" v-model="regForm.username">
        </div>
        <div class="form-item">
          <span class="iconfont icon-youxiang"></span>
          <input type="email" placeholder="请输入邮箱" v-model="regForm.email">
        </div>
        <div class="form-item">
          <span class="iconfont icon-shouji"></span>
          <input type="text" placeholder="请输入手机号码" v-model="regForm.mobile">
        </div>
        <div class="form-item">
          <span class="iconfont icon-mima"></span>
          <input v-model="regForm.password" :type="viewIcon2 ? 'text' : 'password'" placeholder="密码必须3-30个字符">
          <div class="iconfont view-icon" :class="viewIcon2 ? 'icon-yanjing_bi' : 'icon-eye'" @click="viewIcon2 = (!viewIcon2)"></div>
        </div>
        <div class="form-item">
          <span class="iconfont icon-yanzhengma1"></span>
          <input type="text" placeholder="输入图形验证码" style="width: 100px;" v-model="regForm.captcha">
          <img
              id="vdimgck"
              :src="imgSrc"
              class="img-code"
              @click="onResetCode"
              title="看不清,点击刷新"
              alt="">
        </div>
        <div class="form-item">
          <span class="iconfont icon-yanzhengma"></span>
          <input type="text" placeholder="输入短信验证码" style="width: 100px;" v-model="regForm.code">
          <div class="code-btn" @click="onSendCode">{{ code_text_1 }}</div>
        </div>
        <button class="reg-bn" @click="onRegister">注册</button>
        <div class="form-item-footer-text">已有账号？<a href="javascript:void(0);" @click="isAddClass = false">立即登录</a></div>
      </div>
      <div v-if="!isAddClass" class="form-container sign-in-container">
        <h1 class="form-title">欢迎登录</h1>
        <div class="form-box">
          <div class="form-item">
            <span class="iconfont icon-shouji"></span>
            <input v-model="loginForm.mobile" type="text" placeholder="请输入手机号码">
          </div>
          <div class="form-item">
            <span class="iconfont icon-mima"></span>
            <input v-model="loginForm.password" :type="viewIcon ? 'text' : 'password'" placeholder="请输入密码">
            <div class="iconfont view-icon" :class="viewIcon ? 'icon-yanjing_bi' : 'icon-eye'" @click="viewIcon = (!viewIcon)"></div>
          </div>
        </div>

        <div class="form-item-footer">
          <el-checkbox v-model="savePwd" @change="savePassword">记住密码</el-checkbox>
          <a class="" href="javascript:void(0)" @click="$router.push('/login/forget')">忘记密码?</a>
        </div>
        <button class="login-btn" @click="onLogin">登录</button>

        <div class="form-item-footer-text">还没有账号？<a href="javascript:void(0);" @click="isAddClass = true">注册账号</a></div>
      </div>
    </div>

    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import footerBox from "@/components/footerBox/index"
import {apiSendSms, apiUserRegister} from "@/api/api"

export default {
  name: "login",
  components:{headerNav, footerBox},
  data() {
    return {
      imgSrc: this.API_URL+'captcha.html',
      code_text_1: "获取验证码",
      time_1: 60,
      send_1: true,
      isClick: true,
      savePwd: false,
      isAddClass: false,
      viewIcon: false,
      viewIcon2: false,
      loginForm: {
        mobile: "",
        password: ""
      },

      regForm: {
        mobile: '', // 手机号码
        password: '', // 密码
        email: '', // 邮箱
        username: '', // qq
        code: '', // 短信验证码
        captcha: '', // 图形验证码
        url: "",
        event: 'register',
        type: 'email'
      },
      smsParam: {
        mobile: '',
        type: 'mobile',
        event: 'register'
      },
    }
  },
  computed:{
    advert(){
      let info = null;
      let advert = {}
      if(this.$store.getters.advert){
        info = this.$store.getters.advert
      }else{
        info = localStorage.getItem("advertConfig");
        if(info){
          info = JSON.parse(info);
        }
      }
      if(info&&info.index){
        for(let i = 0; i < info.index.length; i++){
          advert[info.index[i].key] = info.index[i];
        }
      }
      return advert;
    },
  },
  watch: {
    'regForm.username'() {
      if (this.regForm.username) {
        this.regForm.email = this.regForm.username + '@qq.com'
      } else {
        this.regForm.email = "";
      }
    }
  },
  mounted() {
    if (this.$route.query.u || this.$route.query.type == 'register') {
      this.isAddClass = true;
    }
    var password = localStorage.getItem("savePassword");
    if (password) {
      this.savePwd = true;
      this.loginForm.password = password;
    }
  },
  methods: {
    onResetCode(){
      this.imgSrc = this.imgSrc+'?rnd=' + Math.random();
    },
    savePassword() {
      if (this.savePwd) {
        localStorage.setItem("savePassword", this.loginForm.password);
      } else {
        localStorage.removeItem("savePassword", this.loginForm.password);
      }
    },
    onSendCode() {
      if (this.regForm.mobile === '') {
        this.$message.info('手机号码不能为空')
        return false
      }
      this.smsParam.mobile = this.regForm.mobile
      if (this.time_1 === 60 && this.send_1) {
        this.send_1 = false
        apiSendSms(this.smsParam).then(res => {
          if (res.code === 1) {
            this.$message.success('已发送')
            this.time1Fun = setInterval(() => {
              if (this.time_1 > 0) {
                this.time_1--
                this.code_text_1 = this.time_1 + 's'
              } else {
                this.time_1 = 60
                this.code_text_1 = '获取验证码'
                this.send_1 = true
                clearInterval(this.time1Fun)
              }
            }, 1000)
          } else {
            this.time_1 = 60
            this.code_text_1 = '获取验证码'
            this.send_1 = true
            clearInterval(this.time1Fun)
          }
        })
      }
    },
    onRegister() {
      if (this.regForm.username === '') {
        this.$message.info('QQ号不能为空')
        return false
      }
      if (this.regForm.email === '') {
        this.$message.info('邮箱不能为空')
        return false
      }
      if (this.regForm.mobile === '') {
        this.$message.info('手机号码不能为空！')
        return false
      }
      if (this.regForm.password === '') {
        this.$message.info('请输入密码！')
        return false
      }
      if (this.regForm.code === '') {
        this.$message.info('请输入验证码！')
        return false
      }
      if (this.isClick) {
        this.isClick = false;
        if(this.$route.query.u){
          this.regForm.url = window.location.href;
        }else{
          this.regForm.url = "";
        }
        apiUserRegister(this.regForm).then(res => {
          if (res.code === 1) {
            this.$message.success('注册成功');
            this.regForm = {
              mobile: '', // 手机号码
              password: '', // 密码
              email: '', // 邮箱
              username: '', // qq
              code: '', // 短信验证码
              captcha: '', // 图形验证码
              event: 'register',
              type: 'email'
            }
            this.isAddClass = false;
          } else {
            this.onResetCode();
          }
          this.isClick = true
        }).catch(error => {
          this.isClick = true
          this.onResetCode();
        })
      }
    },
    onLogin() {
      if (!this.loginForm.mobile) {
        this.$message.error("请输入手机号码")
        return;
      }
      if (!this.loginForm.password) {
        this.$message.error("请输入密码")
        return;
      }
      this.$store.dispatch('loginBy', this.loginForm).then(() => {
        this.$message.success("登录成功");
        this.$store.dispatch('getIndexConfig');
        this.$router.push({path: '/'});
      })
    }
  }
}
</script>

<style scoped>

.login {
  /*height: 100vh;*/
  height: 100%;
  position: relative;
}

.container {
  overflow: hidden;
  width: 1300px;
  /*height: calc(100vh - 232px);*/
  height: 740px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
}
.overlay-container{
  width: 40%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
}
.form-container{
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.form-title{
  color: #0f375a;
  font-size: 22px;
  margin-bottom: 40px;
}
.form-item{
  width: 350px;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.form-item input{
  border: none;
  outline: none;
  flex: 1;
  height: 30px;
}
.form-item input::placeholder{
  color: #cccccc;
}
.form-item .iconfont{
  color: #cccccc;
  display: inline-block;
  margin: 0 10px;
}
.form-item .view-icon{
  font-size: 18px;
  color: #0f375a;
  cursor: pointer;
}
.form-item-footer{
  width: 350px;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #0f375a;
}

button{
  width: 350px;
  height: 45px;
  background: #0f375a;
  border: none;
  color: #ffffff;
  margin-top: 50px;
  cursor: pointer;
}
.form-item-footer-text{
  text-align: center;
  font-size: 12px;
  color: #0f375a;
  margin-top: 10px;
}
.form-item-footer-text a{
  color: #0f375a;
}
.code-btn{
  color: #0f375a;
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #0f375a !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/login/index.vue